import { render, staticRenderFns } from "./PlayerControls.vue?vue&type=template&id=004d7ffc"
import script from "./PlayerControls.vue?vue&type=script&lang=ts"
export * from "./PlayerControls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports